import colors from 'styles/theme/colors';

export default function FacilityNetworkStatusEmptyStateIcon({
  width = 24,
  height = 24,
  color = colors.blue100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M10.25 21.25H2.25C1.85218 21.25 1.47064 21.092 1.18934 20.8107C0.908035 20.5294 0.75 20.1478 0.75 19.75V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H13.629C14.0267 0.75035 14.408 0.908615 14.689 1.19L17.561 4.061C17.7003 4.20036 17.8107 4.36578 17.886 4.54783C17.9614 4.72988 18.0001 4.92498 18 5.122V9.25' />
        <path d='M13.4512 0.75V5.37769H17.9922' />
        <path d='M15.8223 17.7358L17.2733 19.1878L20.1773 15.5588' />
        <path d='M23.25 16.5881C23.2531 18.1405 22.7096 19.6475 21.7095 20.8598C20.7094 22.0721 19.3126 22.917 17.75 23.2549C16.1874 22.917 14.7906 22.0721 13.7905 20.8598C12.7904 19.6475 12.2469 18.1405 12.25 16.5881V14.4405C12.2501 14.1786 12.3296 13.9225 12.4788 13.7042C12.6279 13.4859 12.8401 13.315 13.0888 13.2129C14.5564 12.5812 16.1443 12.2549 17.75 12.2549C19.3557 12.2549 20.9436 12.5812 22.4112 13.2129C22.6599 13.315 22.8721 13.4859 23.0212 13.7042C23.1704 13.9225 23.2499 14.1786 23.25 14.4405V16.5881Z' />
        <path
          d='M8.72852 7.20117H11.1504V10.1084H8.72852V12.5303H5.82129V10.1084H3.40039V7.20117H5.82129V4.7793H8.72852V7.20117Z'
          strokeLinecap='butt'
        />
      </g>
    </svg>
  );
}
